import React from 'react';

const statusMeta = {
  assigned: {
    label: 'Pendiente',
    badge: 'bg-amber-100 text-amber-700',
    accent: 'from-amber-50 to-white border-amber-200',
  },
  in_progress: {
    label: 'En curso',
    badge: 'bg-blue-100 text-blue-700',
    accent: 'from-blue-50 to-white border-blue-200',
  },
  completed: {
    label: 'Finalizado',
    badge: 'bg-emerald-100 text-emerald-700',
    accent: 'from-emerald-50 to-white border-emerald-200',
  },
};

const StockOperatorTasksView = ({ controlSheets, onOpenSheet, Icon, operatorLabel = 'Operario de stock' }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-4 md:p-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">Vista Operario</p>
            <h2 className="text-2xl font-bold text-stone-900">Mis controles</h2>
            <p className="text-sm text-stone-500 mt-1">
              Acceso operativo para revisar planillas de depósito desde celular, tablet o escritorio.
            </p>
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-stone-100 px-3 py-2 text-sm font-semibold text-stone-700 self-start">
            <Icon path="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275" className="w-5 h-5" />
            {operatorLabel}
          </div>
        </div>
      </div>

      {controlSheets.length === 0 ? (
        <div className="bg-white rounded-2xl border border-dashed border-stone-300 p-8 text-center text-stone-500 shadow-sm">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-stone-100 text-stone-400">
            <Icon path="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" className="w-8 h-8" />
          </div>
          <p className="text-lg font-semibold text-stone-700">No hay controles asignados</p>
          <p className="text-sm mt-1">Cuando existan planillas programadas van a aparecer acá.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          {controlSheets.map((sheet) => {
            const meta = statusMeta[sheet.status] || statusMeta.assigned;
            return (
              <button
                key={sheet.id}
                onClick={() => onOpenSheet(sheet)}
                className={`text-left bg-gradient-to-br ${meta.accent} rounded-2xl border shadow-sm p-4 md:p-5 hover:shadow-md transition-all`}
              >
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div>
                    <p className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">Planilla operativa</p>
                    <h3 className="text-xl font-bold text-stone-900 mt-1">{sheet.title}</h3>
                    <p className="text-sm text-stone-500 mt-1">{sheet.locationLabel}</p>
                  </div>
                  <span className={`rounded-full px-3 py-1 text-xs font-bold ${meta.badge}`}>{meta.label}</span>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                  <div className="rounded-xl bg-white/80 border border-stone-200 p-3">
                    <p className="text-stone-400 text-xs uppercase tracking-[0.16em]">Productos</p>
                    <p className="text-xl font-bold text-stone-800 mt-1">{sheet.totalLines}</p>
                  </div>
                  <div className="rounded-xl bg-white/80 border border-stone-200 p-3">
                    <p className="text-stone-400 text-xs uppercase tracking-[0.16em]">Pendientes</p>
                    <p className="text-xl font-bold text-amber-600 mt-1">{sheet.pendingLines}</p>
                  </div>
                  <div className="rounded-xl bg-white/80 border border-stone-200 p-3">
                    <p className="text-stone-400 text-xs uppercase tracking-[0.16em]">Revisados</p>
                    <p className="text-xl font-bold text-emerald-600 mt-1">{sheet.completedLines}</p>
                  </div>
                  <div className="rounded-xl bg-white/80 border border-stone-200 p-3">
                    <p className="text-stone-400 text-xs uppercase tracking-[0.16em]">Diferencias</p>
                    <p className="text-xl font-bold text-rose-600 mt-1">{sheet.diffLines}</p>
                  </div>
                </div>

                <div className="flex items-center justify-between mt-4 pt-4 border-t border-stone-200 text-sm">
                  <div className="text-stone-500">
                    {sheet.dateLabel}
                  </div>
                  <div className="inline-flex items-center gap-2 font-semibold text-blue-700">
                    Abrir planilla
                    <Icon path="M8.25 4.5l7.5 7.5-7.5 7.5" className="w-4 h-4" />
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StockOperatorTasksView;
